// Code review - In Progress
// Documentation - In Progress
import { useEffect } from "react";
import { mainTable } from "../css/Common";
import { useState } from "react";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import ServicesSubCategory from "../popup-containers/ServicesSubCategory";
import { servicesSubCategoryHeaders } from "../components/HeaderAttribute";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import toast from "react-hot-toast";
import * as XLSX from "sheetjs-style";
import {
  BindAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import AddScreenTitle from "../components/AddScreenTitle";
import GridPage from "../components/GridPage";
import Buttons from "../components/Buttons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
const ServicesSubCategoryMaster = () => {
  const location = useLocation();
  //All visible functionality useState hooks handling.
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

  // Services Sub-Category Master insert and edit useState hooks handling .
  const [mstServiceSubCategoryId, setMstServiceSubCategoryId] = useState("");

  const [servicesFields, setServicesFields] = useState({
    category: "",
    subCategory: "",
  });

  const [servicesFieldsError, setServicesFieldsError] = useState({
    categoryError: "",
    subCategoryError: "",
  });

  // Bind dropdown value and bind data value useState hooks handling.
  const [bindServicesSubCategory, setBindServicesSubCategory] = useState([]);
  const [bindCategoryValues, setBindCategoryValues] = useState([]);
  const [serviceSubCategoryData, setServiceSubCategoryData] = useState("");
  const [popUpData, setPopUpData] = useState({});
  const [editMode, setEditMode] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Rowindex, Popup, Pagination, next page and other some useState hooks handling.
  const [rowIndex, setRowIndex] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [popUpOpen, setpopUpOpen] = useState(false);

  // Language translate useState hooks handling.
  const [languageCodeKey, setLanguageCodekey] = useState([]);
  const [languageGetCode, setLanguageGetCode] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  // This function is helping for Language translation .
  useEffect(() => {
    const getLanguageCode = async () => {
      const response = await BindAPI("LanguageAPI/GetLanguage");
      setLanguageCodekey(response.data.Table);
    };
    getLanguageCode();
  }, []);

  useEffect(() => {
    var languageKeys = languageCodeKey.map((item) => item.LanguageKey);
    setLanguageGetCode(languageKeys);
  }, [languageCodeKey]);

  // This function is helping for Popup open .
  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  // This function is helping for Popup close .
  const handleClose = () => {
    setpopUpOpen(false);
  };

  // This function is helped to the viwe, delete, block and unblock
  // input value via rowindex passing for Services Sub-Category .
  const handleServicesSubCategory = async (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    //Sub-Category DropDown Value Start
    const categoryRowData = bindServicesSubCategory[rowIndex];
    const categoryInfo = bindCategoryValues.find(
      (L) => L.value === categoryRowData.MstServicesCategoryId
    );
    const ResultCategory = {
      value: categoryRowData.MstServicesCategoryId,
      label: categoryInfo ? categoryInfo.label : "DefaultLocationLabel",
    };
    //setCategory(ResultCategory);
    setPopUpData(ResultCategory);
    //Sub-Category DropDown Value Start

    setServiceSubCategoryData(bindServicesSubCategory[rowIndex]);
    setMstServiceSubCategoryId(
      bindServicesSubCategory[rowIndex].MstServicesSubCategoryId
    );
  };

  // This is Services  Sub-Category grid page add button visible handling functionality .
  const showadd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };

  // This is ovrall cancel button visible handling functionality .
  const cancel = async () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setIsLoading(false);
    setpopUpOpen(false);
    servicesCategoryData();
    setSelectedRowIndex(null);
    setEditMode(null);
    setSubmitBtnDisabled(false);
    setServicesFields({
      firstName: "",
      middleName: "",
    });

    //clear Error
    setServicesFieldsError({
      firstNameError: "",
      lastNameError: "",
    });
  };

  // This function is helped to edit the input value via rowindex passing and
  // helping to visible handling for Services Sub-Category.
  const handleEdit = async (rowIndex) => {
    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    setServicesFields({
      ...servicesFields,
      category: bindServicesSubCategory[rowIndex].MstServicesCategoryId,
      subCategory: bindServicesSubCategory[rowIndex].ServicesSubCategory_en,
    });

    setMstServiceSubCategoryId(
      bindServicesSubCategory[rowIndex].MstServicesSubCategoryId
    );
  };

  const validate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};

    if (flag === 1 || flag === 2) {
      // Validation logic for the location input
      if (servicesFields.category == "") {
        errors.category = "Select Category*";
      }

      // Validation logic for the userId input
      if (!servicesFields.subCategory?.trim()) {
        errors.subCategory = "Enter Sub-Category";
      }
    }

    setServicesFieldsError({
      ...servicesFieldsError,
      categoryError: errors.category || "",
      subCategoryError: errors.subCategory || "",
    });

    return errors; // Return the errors object containing validation errors (if any)
  };

  // response for those all and passing the rowindex for Services Sub-Category.
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    const firstNameValidation = validate(flag);

    if (Object.keys(firstNameValidation).length !== 0) {
      setIsOpen(true);
    }
    if (Object.keys(firstNameValidation).length === 0) {
      setIsOpen(false);
      var createdBy = sessionStorage.getItem("createdBy");
      if (flag == 1 || flag == 2) {
        const languageKeys = [
          "ta", // Tamil
          "hi", // Hindi
          "mr", // Marathi
          "gu", // Gujarati
          "kn", // Kannada
          "ml", // Malayalam
          "te", // Telugu
          "bn", // Bengali
          "or", // Oriya
        ];
        const translatedTexts = [];
        for (let i of languageKeys) {
          const translateText = await LanguageTranslatorAPI(
            servicesFields.subCategory,
            i
          );
          translatedTexts.push(
            translateText.data.data.translations[0].translatedText
          );
        }
        const data = {
          mstServicesSubCategoryId: mstServiceSubCategoryId
            ? mstServiceSubCategoryId
            : 0,
          mstServicesCategoryId: servicesFields.category,
          servicesSubCategoryEn: servicesFields.subCategory,
          servicesSubCategoryTa: translatedTexts[0],
          servicesSubCategoryHi: translatedTexts[1],
          servicesSubCategoryMr: translatedTexts[2],
          servicesSubCategoryGu: translatedTexts[3],
          servicesSubCategoryKn: translatedTexts[4],
          servicesSubCategoryMl: translatedTexts[5],
          servicesSubCategoryTe: translatedTexts[6],
          servicesSubCategoryBn: translatedTexts[7],
          servicesSubCategoryOr: translatedTexts[8],
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI(
          [data],
          "ServicesSubCategoryAPI/IUDServicesSubCategory"
        );
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Services Sub-Category added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Services Sub-Category data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Services Sub-Category updated successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update Services Sub-Category data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        const data = {
          mstServicesSubCategoryId:
            bindServicesSubCategory[items].MstServicesSubCategoryId,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI(
          [data],
          "ServicesSubCategoryAPI/IUDServicesSubCategory"
        );
        if (flag == 3) {
          if (response.data.Table[0].Result === "D") {
            toast.success(
              "Services Sub-Category data deleted successfully 🗑️",
              1000,
              cancel()
            );
            cancel();
          } else {
            toast.error("Failed to delete Services Sub-Category data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 4) {
          if (response.data.Table[0].Result === "B") {
            toast.success(
              "Services Sub-Category data blocked successfully 🚫",
              1000,
              cancel()
            );
            cancel();
          } else {
            toast.error("Failed to block Services Sub-Category data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 5) {
          if (response.data.Table[0].Result === "UB") {
            toast.success(
              "Services Sub-Category data unblocked successfully ✅",
              1000,
              cancel()
            );
            cancel();
          } else {
            toast.error("Failed to unblock Services Sub-Category data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      }
    } else {
      setSubmitBtnDisabled(false);
      setIsLoading(false);
    }
  };

  // This hook function is helped to bind dropdown value and bind all data
  //from Services Sub-Category master table.
  // Fetch Sub-Category Master Table
  useEffect(() => {
    servicesCategoryData();
  }, []);

  const servicesCategoryData = async () => {
    setIsLoading(true);
    try {
      const response = await BindAPI("ServicesSubCategoryAPI/BindServicesSubCategory");
      setBindServicesSubCategory(response?.data?.Table || []);
    } catch (error) {
      console.error("Failed to fetch sub-category data:", error);
      setBindServicesSubCategory([]);
    } finally {
      setIsLoading(false);
    }
  };


  const servicesSubCategoryHeadersExcel = [
    { title: "S.No" },
    { title: "MstServicesSubCategoryId" },
    { title: "Category" },
    { title: "ServicesSubCategory_en" },
    { title: "ServicesSubCategory_ta" },
    { title: "ServicesSubCategory_hi" },
    { title: "ServicesSubCategory_bn" },
    { title: "ServicesSubCategory_kn" },
    { title: "ServicesSubCategory_ml" },
    { title: "ServicesSubCategory_gu" },
    { title: "ServicesSubCategory_mr" },
    { title: "ServicesSubCategory_te" },
    { title: "ServicesSubCategory_or" },
    { title: "Created By" },
    // { title: "Blocked" },
  ];

  const handleExport = async () => {
    try {
      const response = await BindAPI(
        "ServicesSubCategoryAPI/BindServicesSubCategoryExcel"
      );

      const rows = response?.data?.Table || [];

      if (rows.length === 0) {
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
        return;
      }

      // ✅ pass only string headers
      exportServicesSubCategoryData(
        servicesSubCategoryHeadersExcel.map((col) => col.title),
        rows
      );
    } catch (error) {
      console.error("Services Sub-Category Excel Export Error:", error);
      toast.error("Failed to export Services Sub-Category data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };
  const exportServicesSubCategoryData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Services Sub-Category Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((row, index) => {
      const isAlt = index % 2 === 1;
      const style = isAlt ? { fill: { fgColor: { rgb: "F0F0F0" } } } : {};

      return [
        { v: index + 1, s: style },                           // S.No
        { v: row.MstServicesSubCategoryId, s: style },             // Category
        { v: row.ServicesCategory_en, s: style },             // Category
        { v: row.ServicesSubCategory_en, s: style },          // Sub-Category
        { v: row.ServicesSubCategory_ta, s: style },          // Sub-Category
        { v: row.ServicesSubCategory_hi, s: style },          // Sub-Category
        { v: row.ServicesSubCategory_bn, s: style },          // Sub-Category
        { v: row.ServicesSubCategory_kn, s: style },          // Sub-Category
        { v: row.ServicesSubCategory_ml, s: style },          // Sub-Category
        { v: row.ServicesSubCategory_gu, s: style },          // Sub-Category
        { v: row.ServicesSubCategory_mr, s: style },          // Sub-Category
        { v: row.ServicesSubCategory_te, s: style },          // Sub-Category
        { v: row.ServicesSubCategory_or, s: style },          // Sub-Category
        { v: row.CreatedByName, s: style },                   // Created By
        // { v: row.IsBlocked === 1 ? "Yes" : "No", s: style }, // Blocked
      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTH ================= */
    ws["!cols"] = [
      { width: 5 },   // S.No
      { width: 30 },  // Category
      { width: 30 },  // Category
      { width: 35 },  // Sub-Category
      { width: 35 },  // Sub-Category
      { width: 35 },  // Sub-Category
      { width: 35 },  // Sub-Category
      { width: 35 },  // Sub-Category
      { width: 35 },  // Sub-Category
      { width: 35 },  // Sub-Category
      { width: 35 },  // Sub-Category
      { width: 35 },  // Sub-Category
      { width: 35 },  // Sub-Category
      { width: 30 },  // Created By
      // { width: 15 }, // Blocked
    ];

    /* ================= ROW HEIGHT ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Services Sub-Category Master");
    XLSX.writeFile(wb, "Services_Sub_Category_Master.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };


  // Fetch Category Dropdown
  useEffect(() => {
    const bindServicesCategoryDrpData = async () => {
      try {
        const bindCategoryDataDrp = await BindAPI("ServicesCategoryAPI/BindServicesCategory");
        const bindCategory = bindCategoryDataDrp?.data?.Table?.filter(
          (x) => x.BlockedBy === null
        ) || [];

        const categoryDD = bindCategory.map((item) => ({
          value: item.MstServicesCategoryId,
          label: item.ServicesCategory_en,
        }));

        setBindCategoryValues(categoryDD);
      } catch (error) {
        console.error("Failed to fetch category dropdown:", error);
        setBindCategoryValues([]);
      }
    };

    bindServicesCategoryDrpData();
  }, []);


  const handleUserFieldsChange = (value, name) => {
    setServicesFields({
      ...servicesFields,
      [name]: value,
    });
  };
  useEffect(() => {
    if (location.pathname == "/servicessubcategory") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
      servicesCategoryData();
    }
  }, [location]);
  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Services Sub-Category Master"
          header={servicesSubCategoryHeaders}
          records={bindServicesSubCategory}
          handleEdit={handleEdit}
          handleExportBtn={true}
          handleExport={handleExport}
          handleAction={handleServicesSubCategory}
          showAdd={showadd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full ">
          <AddScreenTitle
            addScreenTitle={addScreenTitle}
            updateScreenTitle={updateScreenTitle}
            title="Services Sub-Category Master"
          />

          <div class={mainTable.firstMainAddScreen}>
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <div>
                      <AutoDropDown
                        classStar="text-red-500"
                        title="Category"
                        options={bindCategoryValues}
                        placeholder="Select"
                        name="category"
                        selectedOption={bindCategoryValues.find(
                          (x) => x.value == servicesFields.category
                        )}
                        controlFunc={(value, e) => {
                          setServicesFieldsError({
                            ...servicesFieldsError,
                            categoryError: value ? "" : "Select Category",
                          });
                          handleUserFieldsChange(value.value, e.name);
                        }}
                        controlFuncBlur={() => {
                          setServicesFieldsError({
                            ...servicesFieldsError,
                            servicesFieldsError: servicesFields.category
                              ? ""
                              : "Select Category",
                          });
                        }}
                        Class="custom-class"
                        tabIndex="1"
                        errorMessage={servicesFieldsError.categoryError}
                      />
                    </div>
                    <div>
                      <InputText
                        classStar="text-red-500"
                        inputType="text"
                        title={"Sub-Category"}
                        name={"subCategory"}
                        content={servicesFields.subCategory}
                        controlFunc={(e) =>
                          setServicesFields({
                            ...servicesFields,
                            subCategory: e.target.value,
                          })
                        }
                        controlFuncBlur={(e) => {
                          setServicesFieldsError((servicesFieldsError) => ({
                            ...servicesFieldsError,
                            subCategoryError:
                              servicesFields.subCategory.length > 0
                                ? ""
                                : "Enter Sub-Category",
                          }));
                        }}
                        errorMessage={servicesFieldsError.subCategoryError}
                      />
                    </div>
                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      handleSubmit={handleSubmit}
                      cancel={cancel}
                      disabledBtn={submitBtnDisabled ? true : false}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleServicesSubCategory}
      >
        <div>
          <PopUpScreenTitle
            title="Services Sub-Category Master"
            setpopUpOpen={handleClose}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <ServicesSubCategory
            data={serviceSubCategoryData}
            data1={popUpData}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default ServicesSubCategoryMaster;
